module.exports = __webpack_public_path__ + "img/reports_financial.c1585d58.png";